import * as Yup from 'yup';
import colonialLogin from '../../../assets/img/loginBG.png';
import logoConstructora from '../../../assets/img/logo_constructora.png';

export const validationSchema = Yup.object().shape({
  usuario: Yup.string()
    .required('Este campo es requerido'),
  password: Yup.string()
    .required('Este campo es requerido')
    .min(6, 'La contraseña debe tener al menos 6 caracteres'),
});

export const initialValues = {
  usuario: '',
  password: '',
};

export const images = {
  loginBackground: colonialLogin,
  logo: logoConstructora,
};

export const ERROR_MESSAGES = {
  GENERIC: 'Ocurrió un error inesperado al iniciar sesión',
  INVALID_CREDENTIALS: 'Usuario o contraseña incorrectos',
  ACCOUNT_DISABLED: 'La cuenta está deshabilitada',
  NO_BRANCHES: 'No tiene sucursales asignadas',
  SESSION_EXPIRED: 'La sesión ha expirado',
};

export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Inicio de sesión exitoso',
  BRANCH_SELECTED: 'Sucursal seleccionada correctamente',
};